import { getData, getList } from '@/api/crud';

export type CatalogKind = 'categories' | 'analyses' | 'biomaterials';
export interface Choice { id: number; value: string }
export interface ImportReport {
    id: number,
    filename: string,
    time: string,
    status: string,
    added: number,
    updated: number,
    hidden: number,
    errorRows: number,
    warnings: string[],
    errors: { sheet: string; row: number; field: string; message: string }[],
}

export const titles = { categories: 'Категории анализов', analyses: 'Виды анализов', biomaterials: 'Биоматериалы' };
export const tabs = Object.fromEntries(Object.entries(titles).map(([id, name]) => [id, { id, name, pathName: `analysis-calculator-${id}` }]));
export const catalogPath = (kind: CatalogKind) => `analysis-calculator/${kind}`;
export const lastImport = () => getData<ImportReport | null>('analysis-calculator/imports/latest', '');

export async function choices(kind: CatalogKind): Promise<Choice[]> {
    const items: Choice[] = [];
    let page = 1;
    let total = 0;
    do {
        const { table } = await getList(catalogPath(kind), { page, items: 200 });
        const rows = Object.values(table.rows) as { id: number; name: string }[];
        items.push(...rows.map(row => ({ id: row.id, value: row.name })));
        total = table.totalItems;
        if (!rows.length) break;
        page++;
    } while (items.length < total);
    return items;
}

export function errorMessage(error: any): string {
    return error.response?.data?.message || error.response?.data?.errors?.root?.[0] || 'Не удалось выполнить запрос. Повторите попытку.';
}
